/* eslint-disable max-lines */
import { S7FloatingLabelModule } from '@eastbanctechru/s7-ui-kit-elements';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModalModule, NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { NgSelectConfig, NgSelectModule } from '@ng-select/ng-select';
import { I18NextModule, I18NextService } from 'angular-i18next';
import { FlatpickrModule } from 'angularx-flatpickr';
import { ReferencesService, RouteActions } from 'core';
import { AccessDeniedComponent } from 'shared/components/generic/access-denied/access-denied.component';
import { ButtonToTopComponent } from 'shared/components/generic/button-to-top/button-to-top.component';
import { CheckboxButtonComponent } from 'shared/components/generic/checkbox-button/checkbox-button.component';
import { CheckboxComponent } from 'shared/components/generic/checkbox/checkbox.component';
import { NotFoundComponent } from 'shared/components/generic/not-found/not-found.component';
import { PageTitleComponent } from 'shared/components/generic/page-title/page-title.component';
import { PreloaderComponent } from 'shared/components/generic/preloader/preloader.component';
import { RadioButtonComponent } from 'shared/components/generic/radio-button/radio-button.component';
import { RadioGenderComponent } from 'shared/components/generic/radio-gender/radio-gender.component';
import { RadioTabComponent } from 'shared/components/generic/radio-tab/radio-tab.component';
import { TagInputItemComponent } from 'shared/components/generic/taginput/tag-input-item.component';
import { TagInputComponent } from 'shared/components/generic/taginput/tag-input.component';
import { TextareaResizableComponent } from 'shared/components/generic/textarea-resizable/textarea-resizable.component';
import { AppendValidationErrorDirective } from 'shared/components/generic/validation-error/append-validation-error.directive';
import { RenderRequiredStarDirective } from 'shared/components/generic/validation-error/render-required-star.directive';
import { ValidationErrorComponent } from 'shared/components/generic/validation-error/validation-error.component';
import { CitiesDropdownComponent } from 'shared/components/references/cities-dropdown/cities-dropdown.component';
import { CountriesDropdownComponent } from 'shared/components/references/countries-dropdown/countries-dropdown.component';
import { OfficesDropdownComponent } from 'shared/components/references/offices-dropdown/offices-dropdown.component';
import { StatesDropdownComponent } from 'shared/components/references/states-dropdown/states-dropdown.component';
import { ApplyAgencyWrapperComponent } from 'shared/components/request/apply-agency-wrapper/apply-agency-wrapper.component';
import { BackToRegistriesButtonComponent } from 'shared/components/request/back-to-registries-button/back-to-registries-button.component';
import { CancelRequestButtonComponent } from 'shared/components/request/cancel-request-button/cancel-request-button.component';
import { CancelRequestModalComponent } from 'shared/components/request/cancel-request-button/cancel-request-modal/cancel-request-modal.component';
import { AppendComparisonTooltipDirective } from 'shared/components/request/comparison/append-comparison-tooltip.directive';
import { ComparisonObjectDirective } from 'shared/components/request/comparison/comparison-object.directive';
import { ComparisonTooltipComponent } from 'shared/components/request/comparison/comparison-tooltip.component';
import { ComparisonDirective } from 'shared/components/request/comparison/comparison.directive';
import { EditedWrapperComponent } from 'shared/components/request/comparison/edited-wrapper.component';
import { HighlightEditedDirective } from 'shared/components/request/comparison/highlight-edited.directive';
import { EditRequestButtonComponent } from 'shared/components/request/section-dropdown/edit-request-button/edit-request-button.component';
import { LifetimeSubmitButtonComponent } from 'shared/components/request/lifetime-submit-button/lifetime-submit-button.component';
import { AgencyStageSubmitButtonComponent } from 'shared/components/request/agency-stage-submit-button/agency-stage-submit-button.component';
import { AutostageSubmitButtonComponent } from 'shared/components/request/autostage-submit-button/autostage-submit-button.component';
import { LifetimeSubmitButtonService } from 'shared/components/request/lifetime-submit-button/lifetime-submit-button.service';
import { RequestHeaderComponent } from 'shared/components/request/request-header/request-header.component';
import { RequestSidebarMobileComponent } from 'shared/components/request/request-sidebar/request-sidebar-mobile.component';
import { RequestSidebarComponent } from 'shared/components/request/request-sidebar/request-sidebar.component';
import { RequestSummaryComponent } from 'shared/components/request/request-summary/request-summary.component';
import { SubmitRequestButtonComponent } from 'shared/components/request/submit-request-button/submit-request-button.component';
import { FocusOnRenderDirective } from 'shared/directives/focus-on-render.directive';
import { NoSpacesDirective } from 'shared/directives/no-spaces.directive';
import { OnlyDigitsDirective } from 'shared/directives/only-digits.directive';
import { OnlyLatinsAndDigitsDirective } from 'shared/directives/only-latins-and-digits.directive';
import { OnlyLatinsDirective } from 'shared/directives/only-latins.directive';
import { ResizeTextareaOnFocusDirective } from 'shared/directives/resize-textarea-on-focus.directive';
import { ToLowerDirective } from 'shared/directives/to-lower.directive';
import { ToUpperDirective } from 'shared/directives/to-upper.directive';
import { DateFormatPipe } from 'shared/pipes/date-format.pipe';
import { EscapeRegExpPipe } from 'shared/pipes/escape-regexp.pipe ';
import { StringArrayJoinPipe } from 'shared/pipes/string-array-join.pipe';
import { SelectFileComponent } from 'shared/components/generic/file-components/select-file/select-file.component';
import { DatepickerComponent } from 'shared/components/generic/datepicker/datepicker.component';
import { PhoneCodeDropdownComponent } from 'shared/components/references/phone-code-dropdown/phone-code-dropdown.component';
import { PhoneNumberFormatPipe } from 'shared/pipes/phoneNumber-format.pipe';
import { ObjectConvertPipe } from 'shared/pipes/object-convert.pipe';
import { PhoneNumberComponent } from 'shared/components/generic/phoneNumber-component/phoneNumber-component';
import { S7CurrencyPipe } from 'shared/pipes/s7-currency.pipe';
import { ComplexDatepickerComponent } from './components/generic/complex-datepicker/complex-datepicker.component';
import { FileUploadComponent } from './components/generic/file-components/file-upload/file-upload.component';
import { ValidationSummaryComponent } from './components/generic/validation-summary/validation-summary.component';
import { AirportsDropdownComponent } from './components/references/airports-dropdown/airports-dropdown.component';
import { CopyRequestButtonComponent } from './components/request/copy-request-button/copy-request-button.component';
import { RequestSidebarPlanerTaskComponent } from './components/request/request-sidebar-planer-task/request-sidebar-planer-task.component';
import { RequestSidebarResumeComponent } from './components/request/request-sidebar/request-sidebar-resume/request-sidebar-resume.component';
import { SectionDropdownComponent } from './components/request/section-dropdown/section-dropdown.component';
import { TakeStageToWorkButtonComponent } from './components/request/take-stage-to-work-button/take-stage-to-work-button.component';
import { ClickOnRenderDirective } from './directives/click-on-render.directive';
import { DataClipboardTargetDirective } from './directives/clipboard.directive';
import { HighlightOnChangeDirective } from './directives/highlight-on-change.directive';
import { HighlightOnClickDirective } from './directives/highlight-on-click.directive';
import { HighlightDirective } from './directives/highlight.directive';
import { MarkFormAsSubmittedDirective } from './directives/mark-form-as-submitted.directive';
import { TrimSiteUrlDirective } from './directives/trim-site-url.directive';
import { AppendBSPBadgePipe } from './pipes/append-BSP-badge.pipe';
import { StageSpecificRequestButtonWrapperComponent } from './components/request/stage-specific-request-button-wrapper/stage-specific-request-button-wrapper.component';
import { FormForChangeMarkingDirective } from './components/request/field-changed-mark/form-for-change-marking.directive';
import { FieldChangedMarkDirective } from './components/request/field-changed-mark/field-changed-mark.directive';
import { FieldChangedMarkComponent } from './components/request/field-changed-mark/field-changed-mark.component';
import { ChangedMarkComponent } from './components/request/field-changed-mark/changed-mark/changed-mark.component';
import { FindByIdPipe } from './pipes/find-by-id.pipe';
import { ArrayMapPipe } from './pipes/array-map.pipe';
import { CurrenciesDropdownComponent } from './components/references/currencies-dropdown/currencies-dropdown.component';
import { AutoTrimValueDirective } from './directives/auto-trim-value.directive';
import { CollapsableContainerWrapperComponent } from './components/generic/collapsable-container-wrapper/collapsable-container-wrapper.component';
import { CollapsableFormBlockComponent } from './components/generic/collapsible-form-block/collapsible-form-block.component';
import { FileViewComponent } from './components/generic/file-components/file-view/file-view.component';
import { OnlyLatinsAndSymbolsAndDigitsDirective } from './directives/only-latins-and-symbols-and-digits.directive';
import { EdsInfoComponent } from './components/eds/eds-info/eds-info.component';
import { EdsStatusComponent } from './components/eds/eds-status/eds-status.component';
import { PoaStatusComponent } from './components/poa/poa-status/poa-status.component';
import { PoaInfoComponent } from './components/poa/poa-info/poa-info.component';
import { UploadFilesButtonComponent } from './components/poa/upload-poa-files/upload-poa-files.component';
import { PoaUploaderComponent } from './components/poa/poa-uploader/poa-uploader.component';
import { PoaInfoViewComponent } from './components/poa/poa-info-view/poa-info-view.component';
import { EdsInfoViewComponent } from './components/eds/eds-info-view/eds-info-view.component';

export function ngSelectDefaultsFactory(i18next: I18NextService): NgSelectConfig {
    return {
        appearance: '', appendTo: '', bindLabel: '', bindValue: '',
        addTagText: i18next.t('shared:ngSelect.addTagText'),
        clearAllText: i18next.t('shared:ngSelect.clearAllText'),
        disableVirtualScroll: true,
        loadingText: i18next.t('shared:ngSelect.loadingText'),
        notFoundText: i18next.t('shared:ngSelect.notFoundText'),
        openOnEnter: true,
        placeholder: i18next.t('shared:ngSelect.placeholder'),
        typeToSearchText: i18next.t('shared:ngSelect.typeToSearchText')
    };
}

@NgModule({
    declarations: [
        CancelRequestButtonComponent,
        SubmitRequestButtonComponent,
        ValidationErrorComponent,
        ValidationSummaryComponent,
        AppendValidationErrorDirective,
        RenderRequiredStarDirective,
        PageTitleComponent,
        PreloaderComponent,
        CancelRequestModalComponent,
        AccessDeniedComponent,
        NotFoundComponent,
        ApplyAgencyWrapperComponent,
        ComparisonTooltipComponent,
        RequestHeaderComponent,
        RequestSidebarComponent,
        ComparisonDirective,
        AppendComparisonTooltipDirective,
        ComparisonObjectDirective,
        TagInputComponent,
        TagInputItemComponent,
        RadioButtonComponent,
        CheckboxComponent,
        CheckboxButtonComponent,
        CitiesDropdownComponent,
        AirportsDropdownComponent,
        CountriesDropdownComponent,
        CurrenciesDropdownComponent,
        StatesDropdownComponent,
        ToLowerDirective,
        ToUpperDirective,
        NoSpacesDirective,
        FocusOnRenderDirective,
        ClickOnRenderDirective,
        HighlightOnChangeDirective,
        HighlightOnClickDirective,
        MarkFormAsSubmittedDirective,
        OnlyDigitsDirective,
        OnlyLatinsAndDigitsDirective,
        OnlyLatinsDirective,
        TrimSiteUrlDirective,
        ResizeTextareaOnFocusDirective,
        DateFormatPipe,
        StringArrayJoinPipe,
        RequestSidebarMobileComponent,
        RequestSidebarPlanerTaskComponent,
        TakeStageToWorkButtonComponent,
        FileUploadComponent,
        OfficesDropdownComponent,
        CopyRequestButtonComponent,
        HighlightDirective,
        RequestSidebarResumeComponent,
        SectionDropdownComponent,
        LifetimeSubmitButtonComponent,
        AgencyStageSubmitButtonComponent,
        AutostageSubmitButtonComponent,
        StageSpecificRequestButtonWrapperComponent,
        AppendBSPBadgePipe,
        ComplexDatepickerComponent,
        RequestSummaryComponent,
        DataClipboardTargetDirective,
        EscapeRegExpPipe,
        BackToRegistriesButtonComponent,
        ButtonToTopComponent,
        TextareaResizableComponent,
        RadioGenderComponent,
        RadioTabComponent,
        EditRequestButtonComponent,
        HighlightEditedDirective,
        EditedWrapperComponent,
        SelectFileComponent,
        FileViewComponent,
        DatepickerComponent,
        PhoneCodeDropdownComponent,
        PhoneNumberFormatPipe,
        ObjectConvertPipe,
        PhoneNumberComponent,
        FormForChangeMarkingDirective,
        FieldChangedMarkDirective,
        FieldChangedMarkComponent,
        ChangedMarkComponent,
        FindByIdPipe,
        ArrayMapPipe,
        AutoTrimValueDirective,
        CollapsableContainerWrapperComponent,
        CollapsableFormBlockComponent,
        EdsInfoComponent,
        EdsStatusComponent,
        OnlyLatinsAndSymbolsAndDigitsDirective,
        PoaStatusComponent,
        PoaInfoComponent,
        UploadFilesButtonComponent,
        PoaUploaderComponent,
        PoaInfoViewComponent,
        EdsInfoViewComponent,
        S7CurrencyPipe
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        NgOptionHighlightModule,
        I18NextModule,
        CancelRequestButtonComponent,
        SubmitRequestButtonComponent,
        ValidationErrorComponent,
        ValidationSummaryComponent,
        AppendValidationErrorDirective,
        RenderRequiredStarDirective,
        PageTitleComponent,
        PreloaderComponent,
        AccessDeniedComponent,
        NotFoundComponent,
        ApplyAgencyWrapperComponent,
        ComparisonTooltipComponent,
        ComparisonDirective,
        ComparisonObjectDirective,
        RequestHeaderComponent,
        RequestSidebarComponent,
        TagInputComponent,
        TagInputItemComponent,
        RadioButtonComponent,
        CheckboxComponent,
        CheckboxButtonComponent,
        CitiesDropdownComponent,
        AirportsDropdownComponent,
        CountriesDropdownComponent,
        CurrenciesDropdownComponent,
        StatesDropdownComponent,
        ToLowerDirective,
        ToUpperDirective,
        NoSpacesDirective,
        FocusOnRenderDirective,
        ClickOnRenderDirective,
        HighlightOnChangeDirective,
        HighlightOnClickDirective,
        MarkFormAsSubmittedDirective,
        OnlyDigitsDirective,
        OnlyLatinsAndDigitsDirective,
        OnlyLatinsDirective,
        TrimSiteUrlDirective,
        AppendComparisonTooltipDirective,
        ResizeTextareaOnFocusDirective,
        DateFormatPipe,
        StringArrayJoinPipe,
        RequestSidebarMobileComponent,
        RequestSidebarPlanerTaskComponent,
        FileUploadComponent,
        OfficesDropdownComponent,
        CopyRequestButtonComponent,
        HighlightDirective,
        TakeStageToWorkButtonComponent,
        SectionDropdownComponent,
        LifetimeSubmitButtonComponent,
        StageSpecificRequestButtonWrapperComponent,
        AppendBSPBadgePipe,
        ComplexDatepickerComponent,
        RequestSummaryComponent,
        DataClipboardTargetDirective,
        EscapeRegExpPipe,
        BackToRegistriesButtonComponent,
        ButtonToTopComponent,
        TextareaResizableComponent,
        RadioGenderComponent,
        RadioTabComponent,
        EditRequestButtonComponent,
        HighlightEditedDirective,
        EditedWrapperComponent,
        SelectFileComponent,
        FileViewComponent,
        DatepickerComponent,
        PhoneCodeDropdownComponent,
        PhoneNumberFormatPipe,
        ObjectConvertPipe,
        PhoneNumberComponent,
        FormForChangeMarkingDirective,
        FieldChangedMarkDirective,
        FieldChangedMarkComponent,
        ChangedMarkComponent,
        FindByIdPipe,
        ArrayMapPipe,
        AutoTrimValueDirective,
        CollapsableContainerWrapperComponent,
        CollapsableFormBlockComponent,
        EdsInfoComponent,
        PoaInfoComponent,
        OnlyLatinsAndSymbolsAndDigitsDirective,
        PoaInfoViewComponent,
        EdsInfoViewComponent,
        AgencyStageSubmitButtonComponent,
        AutostageSubmitButtonComponent,
        S7CurrencyPipe,
        CurrencyPipe
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        I18NextModule,
        NgbPopoverModule,
        NgbTooltipModule,
        NgbModalModule,
        NgSelectModule,
        NgOptionHighlightModule,
        FlatpickrModule,
        TextFieldModule,
        S7FloatingLabelModule
    ],
    providers: [
        {
            deps: [I18NextService],
            provide: NgSelectConfig,
            useFactory: ngSelectDefaultsFactory
        },
        S7CurrencyPipe,
        CurrencyPipe
    ]
})
export class SharedModule {
    public static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                RouteActions,
                ReferencesService,
                LifetimeSubmitButtonService,
                {
                    provide: ValidationErrorComponent,
                    useValue: ValidationErrorComponent
                },
                {
                    provide: ComparisonTooltipComponent,
                    useValue: ComparisonTooltipComponent
                }
            ]
        };
    }
}
